import { mapGetters, mapActions } from 'vuex'
import authMixin from '@/mixins/auth-mixin'
const ArticleItem = () => import(/* webpackChunkName = "c-article-item" */'@/components/ArticleItem')
const AddArticleForm = () => import(/* webpackChunkName = "c-add-form" */'@/components/AddArticleForm')
const Loading = () => import(/* webpackChunkName = "c-loading" */'@/components/Loading')

export default {
  name: 'Article',
  mixins: [authMixin],
  components: {
    ArticleItem,
    AddArticleForm,
    Loading
  },
  data () {
    return {
      visibleAddForm: false,
      editId: '',
      listArticles: [],
      params: {
        page: 1,
        itemPerPage: 20,
        search: ''
      },
      isLastPage: false,
      search: ''
    }
  },
  created () {
    this.successRequest()
  },
  computed: {
    ...mapGetters('article', ['articles']),
    ...mapGetters('user', ['token']),
    selectedEditArticle () {
      return this.articles.find(article => article.id === this.editId) || {}
    },
    isFirstPage () {
      return this.params.page === 1
    }
  },
  methods: {
    ...mapActions('article', ['getArticlesAction', 'deleteArticleAction']),
    handleSuccessDelete () {
      this.$swal({
        icon: 'success',
        title: 'Success Delete',
        showConfirmButton: false,
        timer: 1500
      })
      this.successRequest()
    },
    handleDeleteArticle (id) {
      this.$swal({
        title: 'Apakah Anda Yakin?',
        text: 'Anda tidak akan dapat mengembalikan ini!',
        icon: 'warning',
        confirmButtonText: 'Yes, hapus!',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteArticleAction({
            success: this.handleSuccessDelete,
            data: {
              id: id,
              token: this.token
            }
          })
        }
      })
    },
    toggleAddForm (add = false) {
      if (add) this.editId = ''
      this.visibleAddForm = !this.visibleAddForm
    },
    handleEditArticle (id) {
      this.editId = id
      this.toggleAddForm()
    },
    handleSuccessGetArticles () {
      if (this.articles.length < this.params.itemPerPage) this.isLastPage = true
    },
    handlePagination (direction) {
      if (direction === 'left') this.isLastPage = false
      this.params = {
        page: direction === 'left' ? this.params.page - 1 : this.params.page + 1,
        itemPerPage: this.params.itemPerPage,
        search: this.params.search
      }
      this.successRequest()
    },
    handleSearchArticle () {
      this.params = {
        ...this.params,
        page: 1,
        search: this.search
      }
      this.successRequest()
    },
    resetSearch () {
      this.search = ''
      this.params = {
        ...this.params,
        page: 1,
        search: this.search
      }
      this.successRequest()
    },
    successRequest () {
      this.getArticlesAction({
        success: this.handleSuccessGetArticles,
        data: this.params
      })
    }
  }
}
